import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import clsx from "clsx";
import { usePageHeader } from "@/layout/usePageHeader";
import { BulkMailPage } from "@/pages/mail/BulkMailPage";
import { EmailDesignStudio, SystemMailStudio } from "@/pages/mail/SystemMailStudio";

type Section = "vorlagen" | "design" | "rundmail";

const SECTIONS: { id: Section; label: string; hint: string }[] = [
  { id: "vorlagen", label: "Vorlagen", hint: "Alle Mails, die das System verschickt" },
  { id: "design", label: "Design", hint: "HTML-Rahmen für alle Mails" },
  { id: "rundmail", label: "Rundmail", hint: "Jetzt oder automatisch an mehrere Gäste" },
];

export function MailCenterPage() {
  const { setPageMeta } = usePageHeader();
  const [params, setParams] = useSearchParams();
  const raw = params.get("bereich");
  const section: Section = raw === "vorlagen" || raw === "design" ? raw : "rundmail";

  useEffect(() => {
    setPageMeta({
      title: "E-Mails",
      subtitle: "Vorlagen, Design und Rundmail an einem Ort",
    });
    return () => setPageMeta(null);
  }, [setPageMeta]);

  return (
    <div className="space-y-4">
      <div className="grid gap-2 sm:grid-cols-3" role="tablist" aria-label="E-Mails">
        {SECTIONS.map((item) => (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={section === item.id}
            className={clsx(
              "rounded-xl border px-4 py-3 text-left transition",
              section === item.id
                ? "border-accent bg-accent-soft ring-1 ring-accent"
                : "border-separator bg-card hover:bg-fill-tertiary/50",
            )}
            onClick={() => setParams(item.id === "rundmail" ? {} : { bereich: item.id })}
          >
            <span className="block text-sm font-semibold text-label">{item.label}</span>
            <span className="mt-0.5 block text-xs text-label-secondary">{item.hint}</span>
          </button>
        ))}
      </div>
      {section === "vorlagen" ? <SystemMailStudio /> : null}
      {section === "design" ? <EmailDesignStudio /> : null}
      {section === "rundmail" ? <BulkMailPage embedded /> : null}
    </div>
  );
}
